<template>
    <grid
        ref="grid"
        :isSearch="false"
        :columnDefs="columnDefs"
        :fetchCallback="fetchCallback"
    />
</template>

<script>
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import api from '../../../../api';
import { ADMIN_SUBSCRIBER_SUBSCRIPTION_HISTORY } from '../../../../endpoints';
import grid from '../../../generic/grid/grid.vue';
import { mapGetters } from 'vuex';
export default {
    components: {
        grid,
    },
    data() {
        return {
            rowData: [],
            offset: 0,
            limit: 20,
            sort: 'created',
            desc: true,
            search: '',
        };
    },
    inject: ['userId'],
    computed: {
        ...mapGetters('header', ['userUnicodeDateFormat']),
        columnDefs() {
            return [
                {
                    field: 'created',
                    headerName: 'Date',
                    sort: 'desc',
                    type: 'dateTimeColumn',
                    cellRenderer: ({ data }) =>
                        data &&
                        data.created &&
                        format(
                            parseISO(data.created),
                            `${this.userUnicodeDateFormat} hh:mm:ss`
                        ),
                    minWidth: 190,
                    maxWidth: 190,
                },
                {
                    field: 'message',
                    headerName: 'Message',
                    minWidth: 300,
                },
            ];
        },
        fetchCallback() {
            return ({ offset, limit, sort, desc, search }) => {
                this.offset = offset;
                this.limit = limit;
                this.sort = sort;
                this.desc = desc;
                this.search = search;
                return api.get(
                    `${ADMIN_SUBSCRIBER_SUBSCRIPTION_HISTORY(
                        this.userId
                    )}history/`,
                    {
                        params: {
                            offset,
                            limit,
                            sort,
                            desc,
                            search,
                        },
                    }
                );
            };
        },
    },
    methods: {},
};
</script>